const ACTION_NODE_BUTTON = 'button';
const ACTION_NODE_LINK = 'link';
const ACTION_NODE_ROUTER_LINK = 'router-link';

const ACTION_TYPE_PRIMARY = 'primary';
const ACTION_TYPE_SECONDARY = 'secondary';

const ACTION_NODES = [ACTION_NODE_BUTTON, ACTION_NODE_LINK, ACTION_NODE_ROUTER_LINK];
const ACTION_TYPES = [ACTION_TYPE_PRIMARY, ACTION_TYPE_SECONDARY];

export {
    ACTION_NODE_BUTTON,
    ACTION_NODE_LINK,
    ACTION_NODE_ROUTER_LINK,
    ACTION_NODES,
    ACTION_TYPE_PRIMARY,
    ACTION_TYPE_SECONDARY,
    ACTION_TYPES,
};
